import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.6129 6.2097L7.70711 6.29289L16 14.585L24.2929 6.29289C24.6834 5.90237 25.3166 5.90237 25.7071 6.29289C26.0676 6.65338 26.0953 7.22061 25.7903 7.6129L25.7071 7.70711L17.415 16L25.7071 24.2929C26.0976 24.6834 26.0976 25.3166 25.7071 25.7071C25.3466 26.0676 24.7794 26.0953 24.3871 25.7903L24.2929 25.7071L16 17.415L7.70711 25.7071C7.31658 26.0976 6.68342 26.0976 6.29289 25.7071C5.93241 25.3466 5.90468 24.7794 6.2097 24.3871L6.29289 24.2929L14.585 16L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289C6.65338 5.93241 7.22061 5.90468 7.6129 6.2097Z" })
});
export default SvgClose;
